<template>
    <!-- 耕雲導師書籍及著作 -->
    <div class="taoist">
        <div>
            <div class="flex-between title">
                <div class="titleLeft oneLine">{{title}}</div>
            </div>
            <!-- 二级列表 -->
            <div>
                <div
                    class="content oneLine"
                    v-for="(item1,index1) in content"
                    :key="index1"
                    @click="linkToDetail(item1)"
                >{{index1+1}}、{{item1.news_title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    components: {},
    props: {
        content: {
            type: Array,
            default: () => []
        },
        title:String
    },
    data() {
        return {
            contentStatus: [false, false, false] //控制展开和结束
            // content: [{
            //     title: "耕雲導師書箋及著作",
            //     list: ['邁向生命的圓滿', '禪的認知與修學', '談心', '禪的認知與修學', '禪的認知與修學', '禪的認知與修學']
            //   },
            //   {
            //     title: "耕雲導師簡歴2",
            //     list: [11, 22]
            //   },
            //   {
            //     title: "安祥禪第三集",
            //     list: ['邁向生命的圓滿', '中華禪風的演變', '參學正眼', '無漏行', '佛法在世間']
            //   }
            // ]
        };
    },
    methods: {
        changShowList(index) {
            this.contentStatus.splice(index, 1, !this.contentStatus[index]);
        },
        //文章详情
        linkToDetail(item) {
            this.$router.push({
                path: "/articleDetail",
                query: { name: "opus", id: item.id,title:this.title }
            });
        }
    }
};
</script>

<style scoped>
.taoist {
    color: #333333;
}

.title {
    padding: 0.64rem;
}

.oneLine {
    font-size: 0.8rem;
    line-height: 1.8rem;
    font-size: 0.85rem;
    font-weight: 600;
}

.content {
    /* height: 2.4rem; */
    border-top: 1px dashed #dfdfdf;
    line-height: 1.8rem;
    padding-left: 0.64rem;
    padding-right: 0.64rem;
     font-size: 0.85rem;
}

/* .expand {
    font-size: 0.69rem;
    width: 3.6rem;
  } */
.openBtn {
    width: 4rem;
   flex-shrink:0;
}
.down img {
    width: 0.64rem;
    height: 0.32rem;
    margin-left: 0.2rem;
}
</style>